export default __webpack_public_path__ + "static/media/Instruct.84bd437b.webm";